import { UserType } from 'types/type'
import { CommonResponse, get } from './common'

interface GetProfileResponse {
  name: string
  userType: UserType
  school: string
}
export const getProfile = async (): Promise<CommonResponse<GetProfileResponse>> => {
  return await get('/profile')
}
